import './App.css';
import {useEffect} from 'react'
import Navbar from './components/Navbar';
import Hiro from './components/Hiro';
import SkillConstellation from './components/SkillConstellation';
import TimelineViz from './components/TimelineViz';
import Footer from './components/Footer';
import ParticleNetwork from './components/ParticleNetwork';
import AOS from 'aos';
import 'aos/dist/aos.css';


function App() {
    useEffect(() => {
      document.title = 'Vimal Jaiswal';
      AOS.init({ once: true });
    }, []);
  return (
    <div className="bg-dark-500 min-h-screen relative overflow-hidden">
      <ParticleNetwork />
      <div className="relative z-10 px-6 lg:px-20 xl:px-36">
        <Navbar />
        <Hiro />
        <div className="section-divider my-4"></div>
        <SkillConstellation />
        <div className="section-divider my-4"></div>
        <TimelineViz />
        <div className="section-divider my-4"></div>
        <Footer />
      </div>
    </div>
  );
}

export default App;
